import React, { useEffect, useState } from 'react';

import { timeOptions, operationalHours } from "constant/constant";
// material-ui
import { Box, Button, Card, Grid, Switch, FormControlLabel, Checkbox, Drawer } from '@mui/material';

// project imports
import { AddonTypeOption } from 'constant/constant';
import { TCInput, TCSelect, TCSelectStyle } from 'components/TopCourtComponents/Input/TopCourtInput';
import { TCLabel, TCTitleLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';
import { getParamsFromURL } from 'helper/Params';
import { createAddon, getAddon, getServices, getHistory, updateAddon, getBalance, addBalance } from 'services/addonServices';
import DropZoneComponent from 'components/DropzoneComponent';
import { handleUpload } from 'helper/S3';
import moment from 'moment';
import { getCategories } from 'services/categoryServices';
import { getPlayers } from 'services/playerServices';

import AsyncSelect from 'react-select/async';
import { useNavigate } from 'react-router';

import { getPlaces, getSportCourtTypes } from 'services/placeServices';

import Delete from '@mui/icons-material/Delete';
import ReactQuill from 'react-quill';
import { toastMessage } from 'components/Toast/Toast';

import { getUrlCourtCode } from 'helper/Court';
import { IconClock } from '@tabler/icons';
import AddOnEditHistory from './addonComponent/editHistory';
import StockHistoryTable from './addonComponent/tableStock';
import { isMerchant } from 'helper/Admin';
import TCSchedule from 'views/pages/addon/addonComponent/TCSchedule';

export default function AddAddOn() {
  const [stockHistory, setStockHistory] = useState([])
  const courtPlace = localStorage.getItem('courtPlace') ? JSON.parse(localStorage.getItem('courtPlace'))?.id : null || null

  const [form, setForm] = useState({
    category: null,
    name: "",
    isActive: true,
    itemImages: [],
    schedule: [],
    scheduleOff: [],
    courtTypes: [],
    type: null,
    user: null,
    price: null,
    description: "",
    stock: null,
    validity: null,
    lockEdit: true,
    placeId: null,
    restSchedule: []
  })
  const [players, setPlayers] = useState([])
  const [categories, setCategories] = useState([])
  const [openDrawer, setOpenDrawer] = useState(false)
  const [reload, setReload] = useState(Date.now())
  const [loading, setLoading] = useState(false)

  const [stockAdjustment, setStockAdjustment] = useState("")
  const [stockLoading, setStockLoading] = useState(false)

  const navigate = useNavigate()

  const [joiForm, setJoiForm] = useState({
    category: form.category ? null : "required",
    type: form.type ? null : "required",
    user: form.user ? null : "required",
    name: form.name ? null : "required",
    validity: form.validity ? null : "required",
    price: form.price ? null : "required",
    images: form.itemImages.length > 0 ? null : "required",
    courtType: ((form.courtTypes && form.courtTypes.length > 0) || form.isAllCourt) ? null : "required"
  })

  const [advancedDays, setAdvancedDays] = useState(14)
  const [orderSchedule, setOrderSchedule] = useState([])
  const [courtTypeOption, setCourtTypeOption] = useState([])
  const [width, setWidth] = useState(window.innerWidth)

  const loadCourtType = async () => {
    let { data, error } = await getSportCourtTypes({
      isActive: true
    })
    if (error) { console.log(error) }
    if (data) {
      let courtType = []
      for (let i = 0; i < data.length; i++) {
        courtType.push({
          _id: data[i]._id,
          label: `${data[i].sportTypeId.name} ${data[i].courtTypeId.name}`,
          value: data[i].courtType
        })
      }
      setCourtTypeOption(courtType)
    }
  }

  useEffect(() => {
    loadCourtType()

    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [])

  useEffect(() => {
    let { isEdit, params } = getParamsFromURL(window);
    if (isEdit) { getAddonDetail(params) }
    categoriesLoad()
  }, [])

  const categoriesLoad = async () => {
    let { data, error } = await getCategories({})
    if (error) { console.log(error) }
    if (data) {
      let newData = []
      for (let i = 0; i < data.length; i++) {
        newData.push({
          value: data[i]._id,
          label: data[i].name,
          data: data[i]
        })
      }
      setCategories(newData)
    }
  }

  const loadCourtList = async () => {
    try {
      // let { data, error } = await 
    } catch (error) {
      console.log('error', error)
    }
  }

  useEffect(() => {
    setJoiForm({
      category: form.category ? null : "required",
      type: form.type ? null : "required",
      user: form.user ? null : "required",
      name: form.name ? null : "required",
      validity: form.validity ? null : "required",
      price: form.price != null ? null : "required",
      stock: (form.stock || form.type == AddonTypeOption[0]) ? null : "required",
      images: ((form.itemImages && form.itemImages.length > 0) || (form.type && form.type.value === AddonTypeOption[0].value)) ? null : "required",
      courtType: ((form.courtTypes && form.courtTypes.length > 0) || form.isAllCourt) ? null : "required"
    })
    // setReload(Date.now)
  }, [form])

  const onChange = (e) => {
    // console.log('here check change', e)
    // if (e.user && e.user.data.coachStatus === true) {
    //   Confirm("", "Can't select coach");
    //   return;
    // }
    if (e.price) {
      e.price = Number(e.price)
    }
    if (e.type && e.type.value === AddonTypeOption[0].value) {
      setForm(prev => ({
        ...prev,
        validity: 14
      }))
    } else if (e.type && e.type.value === AddonTypeOption[1].value) {
      setForm(prev => ({
        ...prev,
        validity: 7
      }))
    }
    if (e.type && e.type.value !== AddonTypeOption[0].value &&
      e.type && e.type.value !== AddonTypeOption[1].value) {
      setForm(prev => ({
        ...prev,
        ...e,
        validity: null
      }))
    } else {
      setForm(prev => ({
        ...prev,
        ...e
      }))
    }
  }

  const applyAddonData = async (data) => {
    if (!data) return null

    const type = AddonTypeOption.find(option => option.value === data.type) || AddonTypeOption[0]
    const userId = typeof data.user === 'string' ? data.user : data.user?._id
    const categoryId = typeof data.category === 'string' ? data.category : data.category?._id
    const sportCourtTypeIds = Array.isArray(data.sportCourtTypeId)
      ? data.sportCourtTypeId
        .map(item => typeof item === 'string' ? item : item?._id)
        .filter(Boolean)
      : []

    if (data.type === "service" && data.service) {
      try {
        const { data: serviceData, error: serviceError } = await getServices(data.service)

        if (serviceError) {
          console.log(serviceError)
          setPlayers([])
        } else {
          setPlayers(Array.isArray(serviceData) ? serviceData : [])
        }
      } catch (serviceError) {
        console.log(serviceError)
        setPlayers([])
      }
    } else {
      setPlayers([])
    }

    setForm({
      ...data,
      type,
      validity: data.type === 'service' ? 14 : (data.validity ?? null),
      itemImages: Array.isArray(data.itemImages) ? data.itemImages : [],
      schedule: Array.isArray(data.schedule) ? data.schedule : [],
      restSchedule: Array.isArray(data.restSchedule) ? data.restSchedule : [],
      scheduleOff: normalizeScheduleOff(data.scheduleOff),
      user: userId ? {
        _id: userId,
        value: userId,
        label: typeof data.user === 'object' ? data.user?.name || data.user?.label || '' : ''
      } : null,
      category: categoryId ? {
        _id: categoryId,
        value: categoryId,
        label: typeof data.category === 'object' ? data.category?.name || data.category?.label || '' : '',
        data: typeof data.category === 'object' ? data.category : null
      } : null,
      lockEdit: typeof data.lockSchedule === 'boolean' ? data.lockSchedule : true,
      isAllCourt: typeof data.isAllCourt === 'boolean'
        ? data.isAllCourt
        : sportCourtTypeIds.length === 0,
      courtTypes: sportCourtTypeIds,
      placeId: data.placeId ? {
        label: data.placeId.name || data.placeId.label || '',
        value: data.placeId._id || data.placeId.value,
        merchantId: data.placeId.merchantId || null
      } : null,
    })

    setOrderSchedule(Array.isArray(data.orderSchedule) ? data.orderSchedule : [])
    setReload(Date.now())

    return data
  }

  const getAddonDetail = async (id) => {
    if (!id) return null

    try {
      const { data, error } = await getAddon(id)
      if (error) throw error
      if (!data) throw new Error('Add-on data was not returned')

      const [applyResult, historyResult, balanceResult] = await Promise.allSettled([
        applyAddonData(data),
        getHistory(id),
        getBalance(id)
      ])

      if (applyResult.status === 'rejected') {
        throw applyResult.reason
      }

      if (historyResult.status === 'rejected' || historyResult.value?.error) {
        console.log(
          'Failed to reload add-on history',
          historyResult.status === 'rejected' ? historyResult.reason : historyResult.value.error
        )
      }

      if (balanceResult.status === 'rejected' || balanceResult.value?.error) {
        console.log(
          'Failed to reload stock history',
          balanceResult.status === 'rejected' ? balanceResult.reason : balanceResult.value.error
        )
        setStockHistory([])
      } else {
        setStockHistory(Array.isArray(balanceResult.value?.data) ? balanceResult.value.data : [])
      }

      return data
    } catch (error) {
      console.log(error)
      toastMessage(error.message || 'Failed to reload add-on data', { type: "error" })
      return null
    }
  }

  const loadUserOption = async (input) => {
    if (input.length < 3) {
      return
    }
    try {
      let { data, error } = await getPlayers({
        namePhoneNumber: input.replace("+", ""),
        serviceActive: true
      });
      if (error) throw error
      if (data) {
        if (data.length <= 0) return
        return data.map(value => {
          return {
            label: value.name,
            value: value._id,
            data: value
          }
        })
      }
    } catch (error) {
      console.log(error.message || error)
      return ([])
    }
  }

  const updateOrCreate = () => {
    if (form._id) {
      updateExistingAddon()
    } else {
      createNewAddon()
    }
  }

  const deleteAddonImages = (index) => {
    setForm(prev => ({
      ...prev,
      itemImages: Array.isArray(prev.itemImages)
        ? prev.itemImages.filter((_, imageIndex) => imageIndex !== index)
        : []
    }))
  }

  const createNewAddon = async () => {
    try {
      let body = {
        ...form
      }
      body.category = form.category ? form.category.value || form.category._id : null
      body.user = form.user ? form.user.value || form.user._id : null
      body.placeId = form.placeId ? form.placeId.value : null
      if (form.itemImages) {
        let courtImgs = []
        for (let i = 0; i < form.itemImages.length; i++) {
          if (form.itemImages[i].name) {
            let images = await handleUpload(form.itemImages[i])
            courtImgs = courtImgs.concat(images)
          } else {
            courtImgs = courtImgs.concat(form.itemImages[i])
          }
        }
        body.itemImages = courtImgs
      }
      body.type = body.type ? body.type.value : ''
      // body.courtTypes = form.isAllCourt ? [] : form.courtTypes
      body.sportCourtTypeId = form.isAllCourt
        ? courtTypeOption.map(value => value._id)
        : (Array.isArray(form.courtTypes) ? form.courtTypes : [])

      // if (form.type == AddonTypeOption[1]) {
      //   body.stock = 1
      // }

      const { data, error } = await createAddon({
        ...body,
        lockSchedule: form.lockEdit
      })
      if (error) throw error
      if (!data?._id) throw new Error('Create succeeded but no add-on ID was returned')

      navigate(`/${getUrlCourtCode()}/addon/edit/${data._id}`, { replace: true })
      await getAddonDetail(data._id)

      toastMessage("Create success", {
        type: "success"
      })
    } catch (error) {
      console.log(error)
      toastMessage(error.message || 'Failed to create add-on', { type: "error" })
    } finally {
      setLoading(false)
    }
  }

  const updateExistingAddon = async () => {
    try {
      const body = { ...form }

      if (Array.isArray(form.itemImages)) {
        let courtImgs = []

        for (let i = 0; i < form.itemImages.length; i++) {
          if (form.itemImages[i]?.name) {
            const images = await handleUpload(form.itemImages[i])
            courtImgs = courtImgs.concat(images)
          } else if (form.itemImages[i]) {
            courtImgs = courtImgs.concat(form.itemImages[i])
          }
        }

        body.itemImages = courtImgs
      } else {
        body.itemImages = []
      }

      body.type = body.type ? body.type.value : ''
      body.category = form.category ? form.category.value || form.category._id : null
      body.user = form.user ? form.user.value || form.user._id : null
      body.placeId = form.placeId ? form.placeId.value : null
      body.sportCourtTypeId = form.isAllCourt
        ? courtTypeOption.map(value => value._id)
        : (Array.isArray(form.courtTypes) ? form.courtTypes : [])

      const { data, error } = await updateAddon({
        ...body,
        lockSchedule: form.lockEdit
      })

      if (error) throw error

      const addonId = data?._id || form._id || body._id
      if (!addonId) throw new Error('Update succeeded but no add-on ID was available')

      await getAddonDetail(addonId)

      toastMessage("Update success", {
        type: "success"
      })
    } catch (error) {
      console.log(error)
      toastMessage(error.message || 'Failed to update add-on', { type: "error" })

      if (form._id) {
        await getAddonDetail(form._id)
      }
    } finally {
      setLoading(false)
    }
  }

  const checkButtonDisabled = () => {
    let isDisabled = loading || joiForm.category || joiForm.images || joiForm.name || joiForm.price || joiForm.type;
    if (form.type !== AddonTypeOption[0]) {
      if (form.type === AddonTypeOption[2]) {
        return isDisabled || joiForm.stock
      } else {
        return isDisabled || joiForm.stock || joiForm.validity || joiForm.courtType
      }
    } else {
      return isDisabled || joiForm.validity || joiForm.courtType || joiForm.user
    }
  }

  const handleAddStock = async () => {
    try {

      if (!stockAdjustment) {
        toastMessage("Enter stock amount", { type: "error" })
        return
      }

      setStockLoading(true)

      const { error } = await addBalance({
        _id: form._id,
        stock: Number(stockAdjustment)
      })

      if (error) {
        toastMessage(error.message || "Failed to update stock", { type: "error" })
        setStockLoading(false)
        return
      }

      setStockAdjustment("")
      await getAddonDetail(form._id)

      toastMessage("Stock updated", { type: "success" })
    } catch (err) {
      console.log(err)
      toastMessage(err.message || "Failed to update stock", { type: "error" })
    } finally {
      setStockLoading(false)
    }
  }

  const loadPlaceOptions = async (input) => {
    try {
      let { data, error } = await getPlaces({
        name: input
      });
      if (error) throw error
      if (data) {
        console.log('here data info', data)
        if (data.length <= 0) return
        if (courtPlace != "653f5d9006520fccd4ab4604") {
          const result = data.find(item => item._id == courtPlace);

          if (result) {
            onChange({
              placeId: {
                label: result.name,
                value: result._id,
                merchantId: result.merchantId
              }
            })
          }
        }
        let newData = []
        for (let i = 0; i < data.length; i++) {
          if (!data[i].merchantId) {
            newData.push(
              {
                label: data[i].name,
                value: data[i]._id,
                merchantId: data[i].merchantId
              }
            )
          }
        }
        return newData
        // return data.map(value => {
        //   return {
        //     label: value.name,
        //     value: value._id,
        //     merchantId: value.merchantId
        //   }
        // })
      }
    } catch (error) {
      console.log(error.message || error)
      return ([])
    }
  }


  return (
    <>
      <Card>
        <Grid item container xs={12} md={12} lg={12}>
          <Grid xs={12} md={4.5} lg={4.5} sx={{ p: 1 }}>
            <Box
              sx={{
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Grid container sx={{
                p: 2
              }}>
                {/* <Grid xs={12} md={12} sx={{ p: 1 }}>
                  <TCTitleLabel>{form._id ? 'Update Add-On' : 'Add New Add-On'}</TCTitleLabel>
                </Grid> */}
                {
                  !isMerchant() &&
                  <Grid item xs={12} md={12} sx={{ p: 1 }}>
                    <TCLabel style={{ color: 'rgb(133, 133, 133)' }}>Venue</TCLabel>
                    <AsyncSelect
                      isDisabled={courtPlace != "653f5d9006520fccd4ab4604"}
                      styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                        ...TCSelectStyle,
                      }}
                      placeholder={'Select Places...'}
                      isClearable
                      async
                      defaultOptions
                      loadOptions={loadPlaceOptions}
                      isMulti={false}
                      value={form.placeId} onChange={(e) => { onChange({ placeId: e }) }}
                    />
                  </Grid>
                }
                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                  <TCSelect label={"Category*"} showAlert={joiForm.category} options={categories} value={form.category} onChange={(e) => {
                    onChange({ category: e, price: e?.data?.defaultPrice ?? null })
                  }} />
                </Grid>
                <Grid container item xs={12} md={12} sx={{ p: 1 }} spacing={1}>
                  <Grid item xs>
                    <TCSelect label={"Add-On Type*"} showAlert={joiForm.type} options={AddonTypeOption} value={form.type} onChange={(e) => {
                      onChange({ type: e, stock: e?.value === "rent" ? 1 : '' })
                    }} />
                  </Grid>
                  {
                    (form.type === AddonTypeOption[0]) &&
                    <Grid item xs>
                      <Grid container alig alignItems={'flex-end'} spacing={1}>
                        <Grid item>
                          <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>{"User*"}</TCLabel>
                        </Grid>
                        <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
                          {joiForm.user && <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{joiForm.user}</TCLabel>}
                        </Grid>
                      </Grid>
                      <AsyncSelect
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                          ...TCSelectStyle
                        }}
                        placeholder={'Select User...'}
                        isClearable
                        async
                        defaultOptions
                        loadOptions={loadUserOption}
                        value={form.user} onChange={(e) => { onChange({ user: e, name: e ? e.label : '' }) }}
                      />
                    </Grid>
                  }
                </Grid>
                <Grid item container xs={12} md={12}>
                  <Grid xs={10} md={10} sx={{ p: 1 }}>
                    <TCInput onChange={(e) => onChange({ name: e.currentTarget.value })}
                      // disabled={form.type == AddonTypeOption[0]} 
                      value={form.name} showAlert={joiForm.name} label={"Name*"} />
                  </Grid>
                  <Grid xs={2} md={2} sx={{ p: 1 }} >
                    <TCLabel style={{ marginLeft: 10 }}>Status</TCLabel>
                    <Switch checked={form.isActive} onChange={() => onChange({ isActive: !form.isActive })} />
                  </Grid>
                </Grid>
                {
                  // form.type !== AddonTypeOption[0] &&
                  <Grid item xs={12} md={12} sx={{ p: 1 }}>
                    <Grid item container spacing={1}>
                      <Grid item>
                        <TCLabel>Images{form.type !== AddonTypeOption[0] ? "*" : ''}</TCLabel>
                      </Grid>
                      {
                        joiForm.images &&
                        <Grid item pb={0} ml={-0.5}>
                          <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{joiForm.images}</TCLabel>
                        </Grid>
                      }
                      {<span style={{ fontSize: 10, marginTop: 6, marginLeft: 6 }}>{`(1046x1200 px / ratio 1:1.5)`}</span>}
                    </Grid>
                    <DropZoneComponent
                      className="drop-zone"
                      uploadName='addonImage'
                      file={form.itemImages}
                      isMultiple={true}
                      onDrop={(files, event) => {
                        let currImages = form.itemImages ? form.itemImages : []
                        for (let i = 0; i < files.length; i++) {
                          currImages = currImages.concat(files[i])
                        }
                        onChange({ itemImages: currImages })
                      }}
                    >
                      <div className='dropzone mb-0' style={{
                        textAlign: 'center',
                        minHeight: '150px'
                      }}>
                        <div style={{ padding: 10, alignItems: 'center' }}>
                          <label>
                            <i className='fa fa-upload mr-1' />
                            Drop itemImages to upload
                          </label>
                          <br />
                          <label
                            htmlFor={"addonImage"}
                            style={{ cursor: 'pointer' }}
                            className='dropzone-child mb-0'>
                            or Click to Browse
                          </label>
                          <div style={{ overflowX: 'auto' }}>
                            {
                              (form.itemImages && form.itemImages.length > 0) &&
                              <div style={{ textAlign: 'left' }}>
                                Uploaded file :
                                {
                                  form.itemImages.map((value, index) => {
                                    const imageSource = getAddonImageSource(value)
                                    const imageName = value?.name || (typeof value === 'string' ? value.split('/').pop() : `Image ${index + 1}`)

                                    return (
                                      <div key={`${imageName}-${index}`} className='d-flex mb-1' style={{ textAlign: 'left' }}>
                                        <img src={imageSource} style={{ minWidth: '100px', maxHeight: '50px', objectFit: 'contain' }}
                                          onClick={() => {
                                          }}
                                          alt={imageName}
                                        />
                                        <label className='mt-1 mb-0 ml-1' style={{ alignItems: 'flex-end' }}>
                                          {imageName}
                                          <span style={{ marginLeft: 5, color: 'gray', cursor: 'pointer' }} onClick={() => {
                                            deleteAddonImages(index)
                                          }}>X</span>
                                        </label>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </DropZoneComponent>
                  </Grid>
                }
                <Grid item container xs={12} md={12} sx={{ p: 1 }} spacing={2}>
                  <Grid item xs={9} md={9}>
                    <TCInput value={form.price} showAlert={joiForm.price} onChange={(e) => onChange({ price: e.currentTarget.value.replace(/\D/g, '') })} label={"Price*"} />
                  </Grid>
                  <Grid item xs={3} md={3}>
                    <div style={{ fontWeight: 'bold', marginTop: 35 }}>{(form.type === AddonTypeOption[0] || form.type === AddonTypeOption[1]) ? ' / Session' : ' / Item'}</div>
                  </Grid>
                </Grid>
                {
                  form.type !== AddonTypeOption[2] &&
                  <Grid item container xs={12} md={12} sx={{ p: 1 }}>
                    <Grid xs={12} mb={0.5}>
                      <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>Sport Court Type* <span style={{ fontSize: 11, color: '#f44336' }}>{joiForm.courtType}</span></TCLabel>
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <FormControlLabel control={<Checkbox className='checkboxCont' id="all-court-checkbox" checked={form.isAllCourt ? true : false} onChange={() => {
                        onChange({ isAllCourt: !form.isAllCourt })
                      }} />} label={<TCLabel>Select All</TCLabel>} />
                    </Grid>
                    <Grid item container md={12} xs={12}>
                      {
                        courtTypeOption.map(value => {
                          return (
                            <FormControlLabel control={<Checkbox className='checkboxCont' id={`${value._id}-court-checkbox`} disabled={form.isAllCourt}
                              checked={form.isAllCourt ? true : form.courtTypes ? form.courtTypes.indexOf(value._id) >= 0 : false}
                              onChange={() => {
                                // onChange({allCourt: !form.allCourt})
                                let courtTypes = form.courtTypes || []
                                let currIndex = courtTypes.indexOf(value._id)
                                if (currIndex >= 0) {
                                  courtTypes.splice(currIndex, 1)
                                } else {
                                  courtTypes.push(value._id)
                                }
                                onChange({ isAllCourt: courtTypes.length == courtTypeOption.length, courtTypes: courtTypes })
                              }} />} label={<TCLabel>{value.label}</TCLabel>} />
                          )
                        })
                      }
                    </Grid>
                  </Grid>
                }
                {
                  form.type != AddonTypeOption[0] &&
                  <Grid item xs={12} md={12} sx={{ p: 1 }}>
                    <TCInput disabled={form.type?.value === AddonTypeOption[2].value && form._id} label={"Stock*"} value={form.stock} showAlert={joiForm.stock} onChange={(e) => onChange({ stock: e.currentTarget.value.replace(/\D/g, '') })} />
                  </Grid>
                }
                {
                  (form.type && form.type.value !== AddonTypeOption[2].value) &&
                  <Grid item container xs={12} md={12} sx={{ p: 1 }} spacing={2}>
                    <Grid item xs={10} md={10}>
                      <TCInput disabled={form.type && form.type.value === AddonTypeOption[0].value ? true : form.type && form.type.value === AddonTypeOption[2].value ? true : false} type={"number"} value={form.validity} onChange={(e) => onChange({ validity: e.currentTarget.value })} label={"Advanced Booking"} />
                    </Grid>
                    <Grid item xs={2} md={2}>
                      <div style={{ fontWeight: 'bold', marginTop: 35 }}>{'Days'}</div>
                    </Grid>
                  </Grid>
                }
                <Grid item xs={12} md={12} sx={{ p: 1 }}>
                  <TCLabel>Description</TCLabel>
                  <ReactQuill theme="snow" value={form.description} onChange={(e) => onChange({ description: e })} />
                  {/* <TCInput value={form.description} fullWidth={true} label={"Description"} type={'textarea'} rows={4} onChange={(e) => onChange({ description: e.currentTarget.value })} /> */}
                </Grid>
              </Grid>
            </Box>
          </Grid>
          {form._id && (form.type?.value === "buy" || form.type?.value === "sell") && (
            <Grid xs={12} md={7.5} lg={7.5} sx={{ p: 1 }}>
              <Card sx={{ p: 2 }}>

                <Grid container spacing={2}>

                  <Grid item xs={12}>
                    <TCTitleLabel>Stock History</TCTitleLabel>
                  </Grid>

                  {/* Add Stock */}
                  <Grid item container xs={12} spacing={1} alignItems={"center"} justifyContent={"center"}>
                    <Grid item xs={8}>
                      {/* <TextField
                        label="Adjust Stock (+ / -)"
                        type="number"
                        fullWidth
                        size="small"
                        value={stockAdjustment}
                        onChange={(e) => setStockAdjustment(e.target.value)}
                      /> */}
                      <TCInput
                        placeHolder='Adjust Stock (+ / -)'
                        value={stockAdjustment}
                        showAlert={joiForm.price}
                        onChange={(e) => {
                          const regex = /^[+-]?\d*$/
                          const stock = e.target.value
                          if (regex.test(stock)) {
                            setStockAdjustment(stock)
                          }
                        }}
                      />
                    </Grid>

                    <Grid item xs={4}>
                      <Button
                        variant="contained"
                        fullWidth
                        disabled={stockLoading}
                        onClick={handleAddStock}
                      >
                        Update
                      </Button>
                    </Grid>
                  </Grid>

                  {/* History List */}
                  <Grid item xs={12}>
                    <StockHistoryTable rows={stockHistory} loading={false} />
                  </Grid>

                </Grid>
              </Card>
            </Grid>
          )}
          {
            // (form._id && form.type.value === 'service') &&
            (form.type && form.type.value === 'service') &&
            <Grid xs={12} md={7.5} lg={7.5} sx={{ p: 1 }}>
              <Card sx={{ overflowY: 'scroll' }}>
                <Box
                  sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Grid sx={{ p: 2 }}>
                    <SetOffDay reload={reload} data={form} setAddOnForm={setForm} orderSchedule={orderSchedule} />
                  </Grid>
                </Box>
              </Card>
            </Grid>
          }
          <Drawer anchor="right" open={openDrawer} onClose={() => {
            setOpenDrawer(false)
          }}>
            <AddOnEditHistory key={`${form._id}-${reload}`} id={form._id} setClose={() => { setOpenDrawer(false) }} />
          </Drawer>
          {
            (form && form._id) &&
            <Button
              style={{
                position: 'fixed',
                right: width < 500 ? 0 : -30,
                top: (width < 500) ? 60 : '',
                bottom: (width < 500) ? '' : '55%',
                maxWidth: (width < 500) ? '' : 250,
                minWidth: (width < 500) ? 20 : '',
                transform: (width < 500) ? '' : 'rotate(-90deg)',
                color: 'white',
                backgroundColor: '#0198E1',
                zIndex: 300,
              }}
              onClick={() => {
                setOpenDrawer(true)
              }}
            >
              {width < 500 ? <IconClock /> : "Edit History"}
            </Button>
          }
          <Grid container direction={"row"} sx={{
            mb: 4,
            pl: 4
          }}>
            <Button disabled={checkButtonDisabled()} variant="contained" onClick={() => {
              setLoading(true)
              updateOrCreate()
            }}>{form._id ? "Update" : "Create"}</Button>
          </Grid>
        </Grid>
      </Card>
    </>
  )
}

function SetOffDay({
  data,
  setAddOnForm,
  orderSchedule,
  reload
}) {

  const defaultOperationalHours = operationalHours("08:00")
  const [form, setForm] = useState({
    lockEdit: (data.lockSchedule === false || data.lockSchedule === true) ? data.lockSchedule : true,
    operationalHours: Array.isArray(data.schedule) ? data.schedule : defaultOperationalHours,
    restHours: Array.isArray(data.restSchedule) ? data.restSchedule : defaultOperationalHours,
    scheduleOff: normalizeScheduleOff(data.scheduleOff),
  })
  const [offScheduleForm, setOffScheduleForm] = useState({
    date: null,
    day: null,
    startHours: null,
    endHours: null
  })
  const [listHours, setListHours] = useState(timeOptions)
  const [listEndHours, setListEndHours] = useState(timeOptions)
  const [placeInfo, setPlaceInfo] = useState(null)

  // load current court information

  useEffect(() => {
    setAddOnForm(prev => ({
      ...prev,
      schedule: form.operationalHours,
      lockEdit: form.lockEdit,
      restSchedule: form.restHours,
      scheduleOff: form.scheduleOff
    }))
  }, [form])

  useEffect(() => {
    setForm({
      lockEdit: (data.lockSchedule === false || data.lockSchedule === true) ? data.lockSchedule : true,
      operationalHours: Array.isArray(data.schedule) ? data.schedule : defaultOperationalHours,
      restHours: Array.isArray(data.restSchedule) ? data.restSchedule : defaultOperationalHours,
      scheduleOff: normalizeScheduleOff(data.scheduleOff),
    })
    setOffScheduleForm({
      date: null,
      day: null,
      startHours: null,
      endHours: null
    })
  }, [reload])

  useEffect(() => {
    checkAvailableHours(offScheduleForm.date, timeOptions, setListHours, false)
  }, [offScheduleForm.date])

  useEffect(() => {
    if (offScheduleForm.startHours) {
      let hours = []
      let start = false
      for (let i = 0; i < timeOptions.length; i++) {
        if (start) { hours.push(timeOptions[i]) }
        if (timeOptions[i].value == offScheduleForm.startHours.value) { start = true }
      }
      checkAvailableHours(offScheduleForm.date, hours, setListEndHours, true)
    }
  }, [offScheduleForm.startHours])

  const saveSchedule = async () => {
    if (!offScheduleForm.date) {
      toastMessage("Select date off", {
        toastId: "schedule-failed",
        type: "error"
      }); return;
    }
    if (!offScheduleForm.startHours) {
      toastMessage("Select start hours", {
        toastId: "schedule-failed",
        type: "error"
      }); return;
    }
    if (!offScheduleForm.endHours) {
      toastMessage("Select end hours", {
        toastId: "schedule-failed",
        type: "error"
      }); return;
    }
    let newForm = {
      ...offScheduleForm
    }
    newForm.startHours = offScheduleForm.startHours ? offScheduleForm.startHours.value : ''
    newForm.endHours = offScheduleForm.endHours ? offScheduleForm.endHours.value : ''
    let newOffSchedule = form.scheduleOff
    newOffSchedule = checkAddHours(
      {
        date: newForm.date,
        day: newForm.day,
        startHours: newForm.startHours,
        endHours: newForm.endHours
      },
      form.scheduleOff
    )
    setForm(prev => ({
      ...prev,
      scheduleOff: newOffSchedule
    }))
  }

  const removeOffSchedule = (index) => {
    setForm(prev => ({
      ...prev,
      scheduleOff: Array.isArray(prev.scheduleOff)
        ? prev.scheduleOff.filter((_, scheduleIndex) => scheduleIndex !== index)
        : []
    }))
  }

  const onChange = (e) => {
    console.log('check form information', e)
    setOffScheduleForm(prev => ({
      ...prev,
      ...e
    }))
  }

  const timeStringFormat = (e) => {
    let value = e
    console.log(value)
    return `${value < 10 ? `0${value}` : value}:00`
  }

  const checkAvailableHours = (date, hours, setHours, disableEnd) => {
    const safeOrderSchedule = Array.isArray(orderSchedule) ? orderSchedule : []
    let hasMatchingDate = false

    for (let i = 0; i < safeOrderSchedule.length; i++) {
      if (safeOrderSchedule[i]?.date == date) {
        const bookedHours = normalizeHours(safeOrderSchedule[i]?.hours)
        const newHours = []
        let disable = false

        for (let j = 0; j < hours.length; j++) {
          const optionHour = normalizeTimeString(hours[j]?.value)
          const isBooked = optionHour ? bookedHours.includes(optionHour) : false

          if (isBooked) {
            if (!disable) {
              if (disableEnd) {
                disable = true
                newHours.push({
                  ...hours[j]
                })
              } else {
                newHours.push({
                  ...hours[j],
                  isDisabled: true
                })
              }
            } else {
              newHours.push({
                ...hours[j],
                isDisabled: true
              })
            }
          } else if (disableEnd && disable) {
            newHours.push({
              ...hours[j],
              isDisabled: true
            })
          } else {
            newHours.push(hours[j])
          }
        }

        hasMatchingDate = true
        setHours(newHours)
      }
    }

    if (!hasMatchingDate) {
      setHours(hours)
    }
  }

  const sortedScheduleOff = normalizeScheduleOff(form.scheduleOff)
    .map((item, originalIndex) => ({
      ...item,
      originalIndex
    }))
    .sort((a, b) => {
      if (a.date > b.date) return 1
      if (b.date > a.date) return -1
      return 0
    })


  return (
    <>
      <Grid item container p={2} pt={0}>
        <TCSchedule
          title={"My Schedule"}
          lockEdit={form.lockEdit}
          operationalHours={form.operationalHours}
          restHours={form.restHours}
          orderSchedule={orderSchedule}
          setLockEdit={(lockEdit) => {
            setForm(prev => ({
              ...prev,
              lockEdit: lockEdit
            }))
          }}
          setOperationalHours={(e) => {
            setForm(prev => ({
              ...prev,
              operationalHours: e.operationalHours,
            }))
          }}
          setRestHours={(e) => {
            setForm(prev => ({
              ...prev,
              restHours: e.operationalHours
            }))
          }}
        />
        <Grid item container xs={12} spacing={1}>
          <Grid item xs={12}>
            <TCTitleLabel bold>Exclude (Off)</TCTitleLabel>
          </Grid>
          <Grid item container xs={12} spacing={0.5}>
            <Grid item xs={12}><TCLabel>Date</TCLabel></Grid>
            <Grid item xs={12} md={12} lg={6}>
              <TCInput value={offScheduleForm.date}
                style={{ weekStart: 1 }}
                type="date"
                onChange={(e) => {
                  onChange({
                    date: e.currentTarget.value,
                    day: moment(e.currentTarget.value).format("dddd")
                  })
                }}
                inputProps={{
                  InputProps: {
                    // inputProps: { min: moment(new Date()).format("YYYY-MM-DD"), max: checkAdvancedDays()}
                    inputProps: { min: moment(new Date()).format("YYYY-MM-DD") }
                  }
                }}
              />
            </Grid>
            <Grid item container xs spacing={1}>
              <Grid item xs>
                <TCSelect value={offScheduleForm.startHours}
                  disabled={!offScheduleForm.date}
                  options={listHours}
                  onChange={(e) => {
                    onChange({ startHours: e, endHours: null })
                  }}
                />
              </Grid>
              <Grid item xs>
                <TCSelect value={offScheduleForm.endHours}
                  disabled={!offScheduleForm.startHours}
                  options={listEndHours}
                  onChange={(e) => {
                    onChange({ endHours: e })
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid pt={1} item xs={12} textAlign={"left"}>
            <Button variant='contained' color="primary" onClick={() => {
              saveSchedule()
            }}>Add</Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid item container xs={12} p={2} pt={0} spacing={0.5}>
        {
          sortedScheduleOff.map((value, index) => {
            return (
              <Grid key={`${value.date || 'schedule'}-${value.originalIndex}-${index}`} item xs={12} md={12} lg={6}>
                <Card className="custom-card-style" style={{ border: '1px #0198E1 solid' }}>
                  <Grid p={1} container>
                    <Grid item container>
                      <Grid item xs>
                        <Grid item>
                          <TCLabel bold>{moment(new Date(value.date)).format("ddd, DD/MM/YYYY")}</TCLabel>
                        </Grid>
                        <Grid item container spacing={0.5}>
                          <Grid item>
                            <TCLabel bold>Off Hours :</TCLabel>
                          </Grid>
                          <Grid item>
                            <TCLabel>{formatOffHours(value.hours)}</TCLabel>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={2} textAlign={"right"} onClick={() => {
                        removeOffSchedule(value.originalIndex)
                      }}>
                        <Delete style={{ width: 20, height: 20, color: '#E35480' }} />
                      </Grid>
                    </Grid>
                    <Grid item container>
                      <TCLabel style={{
                        fontSize: 10
                      }}>Last update date :{moment(value.updatedDate).format("YYYY/MM/DD HH:mm:ss")}</TCLabel>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            )
          })
        }
      </Grid>
    </>
  )

}

function normalizeScheduleOff(scheduleOff) {
  if (!Array.isArray(scheduleOff)) return []

  return scheduleOff
    .filter(item => item && typeof item === 'object')
    .map(item => ({
      ...item,
      hours: normalizeHours(item.hours)
    }))
}

function normalizeHours(hours) {
  const values = Array.isArray(hours)
    ? hours
    : (typeof hours === 'string' ? hours.split(',') : [])

  return values
    .map(normalizeTimeString)
    .filter(Boolean)
}

function normalizeTimeString(time) {
  const rawValue = typeof time === 'object' && time !== null
    ? time.value
    : time

  if (typeof rawValue === 'number' && Number.isFinite(rawValue)) {
    const normalizedHour = ((rawValue % 24) + 24) % 24
    return `${String(normalizedHour).padStart(2, '0')}:00`
  }

  if (typeof rawValue !== 'string') return null

  const match = rawValue.trim().match(/^(\d{1,2}):(\d{2})/)
  if (!match) return null

  const hour = Number(match[1])
  const minute = Number(match[2])

  if (
    !Number.isInteger(hour) ||
    !Number.isInteger(minute) ||
    hour < 0 ||
    hour > 23 ||
    minute < 0 ||
    minute > 59
  ) {
    return null
  }

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

function checkAddHours(body, scheduleOff) {
  const normalizedScheduleOff = normalizeScheduleOff(scheduleOff)
  const newStart = toHourNumber(body.startHours)
  let newEnd = toHourNumber(body.endHours, true)

  if (!Number.isFinite(newStart) || !Number.isFinite(newEnd)) {
    return normalizedScheduleOff
  }

  if (newEnd <= newStart) {
    newEnd += 24
  }

  const hoursMapped = buildHoursFromRange(newStart, newEnd)
  if (!hoursMapped.length) return normalizedScheduleOff

  const filteredScheduleOff = normalizedScheduleOff.filter(item => {
    if (item.date !== body.date) return true

    const existingHours = normalizeHours(item.hours)
    if (!existingHours.length) return true

    const existingStart = toHourNumber(existingHours[0])
    let existingEnd = toHourNumber(existingHours[existingHours.length - 1])

    if (!Number.isFinite(existingStart) || !Number.isFinite(existingEnd)) {
      return true
    }

    existingEnd += 1

    if (existingEnd <= existingStart) {
      existingEnd += 24
    }

    return !isOverlapping(
      newStart,
      newEnd,
      existingStart,
      existingEnd
    )
  })

  return [
    ...filteredScheduleOff,
    {
      date: body.date,
      day: body.day,
      hours: hoursMapped,
      cmsUpdate: true,
    }
  ]
}

function toHourNumber(time, treatMidnightAsEnd = false) {
  const normalizedTime = normalizeTimeString(time)
  if (!normalizedTime) return null

  const hour = Number(normalizedTime.slice(0, 2))

  if (treatMidnightAsEnd && hour === 0) {
    return 24
  }

  return hour
}

function isOverlapping(newStart, newEnd, existingStart, existingEnd) {
  return newStart < existingEnd && newEnd > existingStart
}

function buildHoursFromRange(start, end) {
  if (
    !Number.isFinite(start) ||
    !Number.isFinite(end) ||
    end <= start ||
    end - start > 24
  ) {
    return []
  }

  const result = []

  for (let hour = start; hour < end; hour++) {
    const normalizedHour = ((hour % 24) + 24) % 24

    result.push(
      `${String(normalizedHour).padStart(2, '0')}:00`
    )
  }

  return result
}

function formatOffHours(hours) {
  const normalizedHours = normalizeHours(hours)
  if (!normalizedHours.length) return 'Hours unavailable'

  const start = normalizedHours[0]
  const last = normalizedHours[normalizedHours.length - 1]
  const lastHour = toHourNumber(last)

  if (!Number.isFinite(lastHour)) {
    return `${start} - Hours unavailable`
  }

  const endHour = (lastHour + 1) % 24

  return `${start} - ${String(endHour).padStart(2, '0')}:00`
}

function getAddonImageSource(value) {
  if (typeof value === 'string') return value
  if (value?.url) return value.url

  if (typeof Blob !== 'undefined' && value instanceof Blob) {
    return URL.createObjectURL(value)
  }

  return ''
}
